import { yup } from '@framework/validation';

export interface IOutcomeActionDirective {}

export const OutcomeActionDirectiveSchema: yup.ObjectSchema<IOutcomeActionDirective> =
  yup.object({}).noUnknown();
